import React, { useState, useRef, useEffect } from 'react';
import { View, Box, BodyText, HoverEl } from 'modules/styled';

interface PopupProps {
  options: any;
  children?: JSX.Element;
}

export const Popup = ({ options, children }: PopupProps): JSX.Element => {
  const [visible, setVisible] = useState(false);
  const popupEl = useRef(null);

  const hidePopup = (ev: MouseEvent) => {
    if (popupEl.current === ev.target) return;
    if (visible) {
      setVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener('click', hidePopup);
    return window.removeEventListener('click', hidePopup);
  }, []);

  const popupOptions = visible ? (
    <Box
      sx={{
        zIndex: 1000,
        minWidth: '140px',
        top: '25px',
        right: '5px',
        cursor: 'pointer',
        position: 'absolute',
        backgroundColor: 'white',
        textAlign: 'center',
        variant: 'borders.popupBorder',
      }}
    >
      {options.map((option: any, i: number) => (
        <HoverEl bgHover={'lightGreyBg'} key={option.text}>
          <Box
            sx={{
              paddingX: 2,
              paddingY: '8px',
              variant: i < options.length - 1 ? 'borders.shadowBorderBottom' : 'none',
              marginBottom: '1px',
            }}
            // @ts-ignore
            onClick={() => {
              setVisible(false);
              option?.action();
            }}
          >
            <BodyText sx={{ color: 'blue' }}>{option.text}</BodyText>
          </Box>
        </HoverEl>
      ))}
    </Box>
  ) : null;

  return (
    <View
      // @ts-ignore
      onClick={(e: React.MouseEvent) => {
        setVisible(!visible);
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      {visible ? (
        <View
          sx={{
            // This overlay only covers the post and menu
            position: 'fixed',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 100,
          }}
        />
      ) : null}
      <Box
        ref={popupEl}
        sx={{ position: 'relative', userSelect: 'none', zIndex: 1, cursor: 'pointer' }}
      >
        {children}
      </Box>
      {popupOptions}
    </View>
  );
};

export default Popup;
